import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { generatePayBySquareData, generateVariableSymbol } from '@posUtils';
import QRCode from 'qrcode';

@Injectable({
  providedIn: 'root',
})
export class QrCodeService {
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  generatePayBySquareData = generatePayBySquareData;
  generateVariableSymbol = generateVariableSymbol;

  async generateQrCodeDataUrl(data: string): Promise<string | null> {
    if (!this.isBrowser) return null;

    try {
      return await QRCode.toDataURL(
        [ { data, mode: 'alphanumeric' as const } ],
        {
          width: 200,
          margin: 2,
          errorCorrectionLevel: 'M',
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        },
      );
    } catch {
      return null;
    }
  }
}
